















































import {Vue, Component} from 'vue-property-decorator';
import ServiceCatalogService from '@/services/ServiceCatalogService';
import ServiceCatalogItemDTO from '@/dto/sales/catalog/ServiceCatalogItemDTO';
import AddServiceCatalogItemModal from './AddServiceCatalogItemModal.vue';
import UpdateServiceCatalogPriceModal from './UpdateServiceCatalogPriceModal.vue';

@Component({})
export default class ServiceCatalogItems extends Vue {
  private items: ServiceCatalogItemDTO[] = [];

  async mounted(): Promise<void> {
    await this.loadCatalog();
  }

  public async loadCatalog(): Promise<void> {
    if (this.$loadOn) this.$loadOn();
    try {
      const response = await ServiceCatalogService.getCatalog();
      this.items = response.data;
    } catch (e) {
      console.error('Failed to load service catalog', e);
    } finally {
      if (this.$loadOff) this.$loadOff();
    }
  }

  public openAddModal(): void {
    (this as any).$modal.show(
      AddServiceCatalogItemModal,
      {
        onSuccess: () => this.loadCatalog()
      },
      {
        height: 'auto',
        width: '700px',
        adaptive: true,
        clickToClose: false
      }
    );
  }

  public openUpdatePriceModal(item: ServiceCatalogItemDTO): void {
    (this as any).$modal.show(
      UpdateServiceCatalogPriceModal,
      {
        item,
        onSuccess: () => this.loadCatalog()
      },
      {
        height: 'auto',
        width: '600px',
        adaptive: true,
        clickToClose: false
      }
    );
  }

  public formatPrice(priceCents: number | null): string {
    if (priceCents === null || priceCents === undefined) {
      return '—';
    }
    return `$${(priceCents / 100).toFixed(2)}`;
  }

  public formatDate(dateStr: string): string {
    if (!dateStr) return '';
    return (this as any).$dateUtils.formatDate(new Date(dateStr));
  }
}
